// Service Worker Registration for PWA

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = '/service-worker.js';

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('Service Worker registered successfully:', registration.scope);

          // Check for updates
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // New content is available
                  console.log('New content is available; please refresh.');
                  
                  // Show update notification to user
                  if (window.confirm('A new version of Fish on Fire is available. Reload to update?')) {
                    window.location.reload();
                  }
                } else {
                  // Content is cached for offline use
                  console.log('Content is cached for offline use.');
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Check if app can be installed
export function checkInstallPrompt(setInstallPrompt) {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later
    setInstallPrompt(e);
    console.log('Install prompt available');
  });
}

// Trigger install prompt
export async function promptInstall(installPrompt) {
  if (!installPrompt) {
    console.log('Install prompt not available');
    return false;
  }

  // Show the install prompt
  installPrompt.prompt();

  // Wait for the user to respond to the prompt
  const { outcome } = await installPrompt.userChoice;
  console.log(`User response to install prompt: ${outcome}`);

  return outcome === 'accepted';
}
